<template>
  <div class="patient-detial" v-if="showPage">
    <div class="menu-background"></div>

    <div class="menu-content">
      <!-- 个人资料卡片 -->
      <div class="menu-top">
        <div class="container">
          <div class="avatar">
            <div class="avatar-background">
              <div class="up-layer">{{papid}}</div>
            </div>
          </div>
          <div class="patient-info">
            <div class="name">{{ name }}</div>
            <!-- <div class="info_text">{{ binding }}</div> -->
            <div class="info_text">手机号: {{mobile.substring(0,4)}}****{{mobile.substring(8,12)}}</div>
            <div class="info_text">状态: {{ front_status }}</div>
            <div class="info_text" v-if="front_status == '援助暂停'">援助暂停原因: {{ transientReason }}</div>
          </div>
          <div class="top-right">
            <van-button  v-if="showBtn" class="button" type="primary" size="mini" color="#0AA8AF">帮助转诊</van-button>
          </div>
        </div>
        <van-cell @click="addPatient()" title="患者基本信息" is-link  />

      </div>
      <div class="patiest-status">
        <van-icon class="" name="checked" />
        <div class="status">
          <div v-if="content"> {{content}}  </div>
          <div v-if="remark">{{remark}}</div>
          <div v-if="username&&username.indexOf('公益专员')>=0">
            当前操作为{{username}}操作
          </div>
          <div v-if="time">{{time}}</div>
        </div>
      </div>

<van-collapse v-model="activeName" accordion >
  <van-collapse-item  :name="index1" v-for="item1,index1 in items1" :key="index1">
    <template #title> 第{{index1}}次申请 </template>

    <van-cell @click="gophaseCheck(index1,index2,item1[index2])" v-for="item2,index2 in item1" :key="index2" class="collapse-item" is-link>
      第{{item1[index2]}}阶段援助
    </van-cell>

  </van-collapse-item>

</van-collapse>



      <div class="tips_text">{{tips_text}}</div>


      <div class="checkin-btn">
        <van-button v-if="showOperateBtn" @click="next()" :disabled="submitBtnDisabled" type="info" round block color="#0AA8AF">进行操作</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Grid, GridItem, Badge } from "vant";
import { getApplys,hasPatient } from '@/api/publicWelfareStaff';
import { checkin, GetPatient } from "@/api/api";
import { mapGetters } from 'vuex'
import Vue from "vue";
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Badge);
export default {
  data() {
    return {
      showPage:true,

      papid:'',
      patient_id:'',
      name: "",
      // binding: "已绑定",
      mobile: "",
      front_status: "",
      submitBtnDisabled: true,
      transientReason:'',
      username:'',
      content:'',
      remark:'',
      time:'',

      items1:[],
      activeName:'',

      showBtn:false,//帮助转诊
      showOperateBtn:false,

      tips_text:'',
    };
  },
  computed: {
    ...mapGetters(['getAddUploadStatus'])
  },
  async created() {
    console.log('this.getAddUploadStatus',this.getAddUploadStatus)
    if(this.$route.query.name) this.name=this.$route.query.name
    if(this.$route.query.mobile) this.mobile=this.$route.query.mobile
    // if(this.$route.query.front_status) this.front_status=this.$route.query.front_status
    if(this.$route.query.papid) this.papid=this.$route.query.papid
    // if(this.$route.query.patient_id) this.patient_id=this.$route.query.patient_id


    await this.init()
    //这些情况下没有操作按钮
    // if(this.front_status.indexOf('纸质材料')>=0) this.showOperateBtn=false
    // if(this.front_status.indexOf('人脸识别已上传')>=0) this.showOperateBtn=false
    // if(this.front_status.indexOf('待领药')>=0) this.showOperateBtn=false
    // if(this.front_status.indexOf('出组')>=0) this.showOperateBtn=false
    // if(this.front_status.indexOf('解锁材料上传')>=0){
    //   if(this.front_status.indexOf('材料已上传')>=0) this.showOperateBtn=false
    // }
    //上面作废-暂存

    //这些情况下有操作按钮
    // this.front_status='申请领药（材料未上传）'
    if(this.hasString(this.front_status,'入组审核申请','未')) this.showBtnAndText1();
    if(this.getAddUploadStatus) this.showBtnAndTextSpecial();
    // if(this.hasString(this.front_status,'入组审核申请','已')) this.showBtnAndTextSpecial();
    if(this.hasString(this.front_status,'申请领药','未')) this.showBtnAndText1();
    // if(this.hasString(this.front_status,'申请领药','已')) this.showBtnAndTextSpecial();
    if(this.hasString(this.front_status,'本阶段援助结束')) this.showBtnAndText2();
    if(this.hasString(this.front_status,'阶段审核申请','未')) this.showBtnAndText1();
    // if(this.hasString(this.front_status,'阶段审核申请','已')) this.showBtnAndTextSpecial();
    if(this.hasString(this.front_status,'解锁材料上传','未')) this.showBtnAndText1();
    // if(this.hasString(this.front_status,'解锁材料上传','已')) this.showBtnAndTextSpecial();
    if(this.hasString(this.front_status,'待完善资料')) this.showBtnAndText3();
    if(this.hasString(this.front_status,'人脸识别未')) this.showBtnAndText3();
    // if(this.hasString(this.front_status,'逾期未领药')) this.showBtnAndText3();
    if(this.hasString(this.front_status,'逾期解锁待电话')) this.showBtnAndText3();
    if(this.hasString(this.front_status,'援助暂停')) this.showBtnAndText3();
    this.submitBtnDisabled=false;//提交按钮解禁

    //下面作废-暂存
    // //提示文字
    // if(this.front_status.indexOf('待完善资料')>=0) this.tips_text='你可以通知TA'
    // if(this.front_status.indexOf('入组审核申请')>=0) this.tips_text='你可以为TA上传预约申请材料'
    // // if(this.front_status.indexOf('处方未')>=0) this.tips_text='你可以为TA申请领药'
    // if(this.front_status.indexOf('申请领药')>=0) this.tips_text='你可以为TA申请领药'
    // if(this.front_status.indexOf('人脸识别未')>=0) this.tips_text='你可以通知TA'
    // if(this.front_status.indexOf('本阶段援助结束')>=0) this.tips_text='你可以为TA开启下一阶段'
    // if(this.front_status.indexOf('阶段审核申请')>=0) this.tips_text='你可以为TA申请领药'
    // // if(this.front_status.indexOf('逾期未领药')>=0) this.tips_text='你可以通知TA'
    // if(this.front_status.indexOf('逾期解锁待电话')>=0) this.tips_text='你可以通知TA'
    // if(this.front_status.indexOf('解锁材料上传')>=0){
    //   if(this.front_status.indexOf('材料未')>=0)  this.tips_text='你可以为TA上传解锁材料'
    // }

    // this.showPage=true;
  },
  mounted() {},
  methods: {
    showBtnAndText1(){
      this.showOperateBtn=true
      this.tips_text='你可以为TA上传材料'
    },
    showBtnAndTextSpecial(){
      this.showOperateBtn=true
      this.tips_text='你可以为TA上传材料'
    },
    showBtnAndText2(){
      this.showOperateBtn=true
      this.tips_text='你可以为TA开启下一阶段'
    },
    showBtnAndText3(){
      this.showOperateBtn=true
      // this.tips_text='你可以通知TA'
      this.tips_text=''
    },
    async init(){
      if (this.papid ) {//apply提交过资料
        await getApplys({papid: this.papid}).then(res=>{
          console.log("getApplys",res)
          if(res.data){
            this.front_status=res.data.front_status
            this.$store.commit('setFrontStatus',res.data.front_status)
            if(res.data.current){
              const DATA=res.data.current
              this.username=DATA.username
              this.content=DATA.content
              this.remark=DATA.remark
              this.time=DATA.created
            }
            if(res.data.phase_cate){
              // console.log("res.data.phase_cate",res.data.phase_cate)
              this.items1=res.data.phase_cate
            }
          }
        }).catch(err => {
          console.log("getApplys出错:",err)
          return
        })
        //如果不需要公益专员操作的话 不用调用下面的接口
        // if(this.noStore()) return

        await GetPatient({papid: this.papid}).then(res => {
          console.log("GetPatient返回数据:",res)
          this.transientReason = res.data.transientReason
          this.$store.commit("setPatientInfo",res.data );
          this.$store.commit("setAddUploadStatus",res.data.addUploadStatus );
          //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!patientInfo是GetPatient获取的数据
        });
        await hasPatient({papid: this.papid}).then(res => {
          console.log("hasPatient返回:",res)
          this.patient_id=res.data.id
          if(!this.mobile) this.mobile=res.data.mobile
        }).catch(err => {
          console.log("hasPatient出错:",err)
          return
        })
      }
      if(this.patient_id){
        let self = this
        await checkin({patient_id:this.patient_id}).then(res => {
          console.log("checkin返回数据:", res);
          if (res.data) {
            this.$store.commit("setPatientOne", { patientOne: res.data });
            //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!patientOne是checkin获取的数据
            let userInfo = this.$store.getters.getUserInfo;
            userInfo.patient = res.data
            this.$store.commit("setUserInfo", userInfo);
          }
        }).catch(err => {
          console.log("checkin出错:",err)
          return
        })
      }
    },
    // 搜索字符串string中是否存在...args中的全部参数,有则返回true 无返回false
    hasString(string,...args){
      if(!string){
        console.log("要匹配的字符串string为空")
        return
      }
      // console.log(string,...args)
      for(let i in args){
        if(string.indexOf(args[i])<0){
          console.log("在'"+string+"'中未匹配到:",args[i])
          return false
        }
      } 
      console.log("!在'"+string+"'中匹配到:",...args)
      return true
    },
    noStore(){
      if(this.front_status.indexOf('纸质材料')>=0) return true
      if(this.front_status.indexOf('人脸识别')>=0) return true
      if(this.front_status.indexOf('待领药')>=0) return true
      if(this.front_status.indexOf('出组')>=0) return true
      if(this.front_status.indexOf('解锁材料上传')>=0){
        if(this.front_status.indexOf('材料已上传')>=0) return true
      }
      if(this.front_status.indexOf('待完善资料')>=0) return true
      // if(this.front_status.indexOf('逾期未领药')>=0) return true
      if(this.front_status.indexOf('逾期解锁待电话')>=0) return true
    },
    addPatient(){
      this.$router.push({name:'addPatient',query:{papid:this.papid}})
    },
    gophaseCheck(round,phase,show_phase){
      this.$router.push({name:'phaseCheck',query:{papid:this.papid,phase:phase,round:round,show_phase:show_phase}})
    },
    next(){
      let route=''
      let query={}
      if(this.front_status.indexOf('待完善资料')>=0){
        route='patientDetails'
        query={
          noticeText:`请及时通知患者${this.name}登录微信,做人脸识别和签署知情同意书`,
          copyText:this.mobile
        }
      }
      if(this.front_status.indexOf('审核申请')>=0){
        console.log('21312313');
        route='patientUpload'
      }
      if(this.front_status.indexOf('申请领药')>=0){
        route='patientAppointment'
      }
      if(this.front_status.indexOf('人脸识别未')>=0){
        route='patientDetails'
        query={
          noticeText:`请为患者${this.name}提供人脸识别指导`,
          copyText:this.mobile
        }
      }
      // if(this.front_status.indexOf('逾期未领药')>=0){
      if(this.front_status.indexOf('逾期解锁待电话')>=0){
        route='patientDetails'
        query={
          noticeText:`请为患者${this.name}提供重新预约指导`,
          copyText:this.mobile
        }
      }
      if(this.front_status.indexOf('解锁材料上传')>=0){
        route='patientUpload'
      }
      if(this.front_status.indexOf('本阶段援助结束')>=0){
        route='PatientChooseTime'
      }
      if(this.front_status.indexOf('援助暂停')>=0){
        route='patientDetails'
        query={
          noticeText:`请为患者${this.name}提供重新预约指导`,
          copyText:this.mobile
        }
      }
      // if(this.front_status.indexOf('逾期未领药')>=0){
      //   route='staffNextphase'
      // }


      this.$router.push({name:route,query:query})
    },
    // getRound_phase(Round,Phase){
    //   // console.log("!",Round,Phase)
    //   let round=parseInt(Round)
    //   let phase=parseInt(Phase)
    //   let minus=0
    //   let round_phase=0
    //   minus=round==1?0:round==2?2:round==3?27:0
    //   console.log("round:",round,"phase:",phase,"round_phase:",round_phase,"minus:",minus)

    //   round_phase=phase-minus

    //   return round_phase
    // },
  },
};
</script>

<style lang="scss" scoped>
.patient-detial {
  min-height: 100vh;
  background-color: #f9f9f9;
  // padding-top: 20px;
  ::v-deep .van-collapse-item__content{
    padding:0;
  }

  .menu-background {
    height: 25vh;
    background: #0aa8af;
  }
  .menu-content {
    margin-top: -15vh;
    padding-bottom: 5vh;
    .menu-top {
      font-size: 16px;
      margin: 0 25px 15px 25px;
      padding: 20px 20px 10px 20px;
      // min-height: 25vh;
      line-height: 20px;
      border-radius: 10px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      background: white;

      
      .container {
        // margin-bottom: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        // background:#ccc;
        position:relative;
        .top-right{
          position: absolute; top: 0px; right: 0; text-align: right;display: flex;justify-content:flex-end;align-items:center;
          .button{
            // background-color:#13AFB6;
            text-align: right;
            border-radius: 2px;
            color: white;
            display: flex;
            justify-content:center;
            align-items:center;
            padding: 2px 10px;
            font-size: 14px;
            // box-shadow: 0 0 4px #0AA8AF;
          }
        }
      }
      .avatar {
        margin: -5px 0 5px -5px;
        .avatar-background {
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
          padding: 3px;
          border-radius: 100%;
          background: #f9f9f9;

          display: flex;
          justify-content: center;
          align-items: center;
          .up-layer{
              color:white;
              font-weight:bold;
              width: 60px;
              height: 60px;
              font-size:20px;
              background-color: #8ddbdf;
              // padding:5px;
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
          }
        }
      }
      .patient-info {
        padding-left: 3vw;
        // word-break: break-all;
        .name {
          font-size: 16px;
          font-family: PingFangSC-Regular;
        }
        .info_text{
          font-size: 14px;
          color: #101010;
          font-family: PingFangSC-Regular;
        }
      }
    }
    .patiest-status{
      font-size: 16px;
      margin: 0 25px 15px 25px;
      padding: 20px;
      // min-height: 25vh;
      line-height: 20px;
      border-radius: 10px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      background: white;
      color:#31BC08 ;

      display: flex;
      justify-content: flex-start;
      align-items: center;

      .status{
        padding-left: 10px;
      }
    }
  }
  .tips_text{
    text-indent: 15px;
    font-size: 14px;
    margin-top: 10px;

  }
  .checkin-btn {
    margin: 25px;
  }
}
</style>